import { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './config/redux';
import SentryUtility from './config/sentry/index.ts';
import './index.css';
import { ReactQueryProvider } from './providers';
import { retry } from './utils/retry.ts';
import ErrorBoundary from './views/partner/home/error-fallback.tsx';

if (!SentryUtility.isLocalhost()) {
  // SentryUtility.init();
}

// ** Lazy load app
const LazyApp = lazy(() => retry(() => import('./App')));
ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <ReactQueryProvider>
          <Toaster position='top-right' />
          <ErrorBoundary>
            <LazyApp />
          </ErrorBoundary>
      </ReactQueryProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode >
  ,
);